var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27067 2.33333C5.12109 2.33333 4.99984 2.45459 4.99984 2.60417V4.14387C4.99984 4.51206 4.70136 4.81053 4.33317 4.81053C3.96498 4.81053 3.6665 4.51206 3.6665 4.14387V2.60417C3.6665 1.71821 4.38471 1 5.27067 1H13.3957C14.2816 1 14.9998 1.71821 14.9998 2.60417V10.7292C14.9998 11.6151 14.2816 12.3333 13.3957 12.3333H11.8386C11.4704 12.3333 11.1719 12.0349 11.1719 11.6667C11.1719 11.2985 11.4704 11 11.8386 11H13.3957C13.5452 11 13.6665 10.8787 13.6665 10.7292V2.60417C13.6665 2.45459 13.5452 2.33333 13.3957 2.33333H5.27067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.729 4.33331H2.604C2.08624 4.33331 1.6665 4.75305 1.6665 5.27081V13.3958C1.6665 13.9136 2.08624 14.3333 2.604 14.3333H10.729C11.2468 14.3333 11.6665 13.9136 11.6665 13.3958V5.27081C11.6665 4.75305 11.2468 4.33331 10.729 4.33331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5.27085C1 4.3849 1.71821 3.66669 2.60417 3.66669H10.7292C11.6151 3.66669 12.3333 4.3849 12.3333 5.27085V13.3959C12.3333 14.2818 11.6151 15 10.7292 15H2.60417C1.71821 15 1 14.2818 1 13.3959V5.27085ZM2.60417 5.00002C2.45459 5.00002 2.33333 5.12128 2.33333 5.27085V13.3959C2.33333 13.5454 2.45459 13.6667 2.60417 13.6667H10.7292C10.8787 13.6667 11 13.5454 11 13.3959V5.27085C11 5.12128 10.8787 5.00002 10.7292 5.00002H2.60417Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.86864a33.svg";
export { ForwardRef as ReactComponent };